interface DATAITM {
  [key: string]: {
    [key: string]: number | string;
  };
}
export const phone_data: DATAITM = {
  acode: {
    AF: 93,
    AL: 355,
    AD: 376,
    AO: 244,
    AI: 1264,
    AG: 1268,
    AQ: 672,
    AR: 54,
    AS: 1684,
    AM: 374,
    AT: 43,
    AU: 61,
    AW: 297,
    AZ: 994,
    BS: 1242,
    BH: 973,
    BD: 880,
    BB: 1246,
    BY: 375,
    BE: 32,
    BZ: 501,
    BJ: 229,
    BL: 590,
    BM: 1441,
    BT: 975,
    BO: 591,
    BA: 387,
    BW: 267,
    BR: 55,
    VG: 1284,
    BN: 673,
    BG: 359,
    BF: 226,
    MM: 95,
    BI: 257,
    KH: 855,
    CA: 1,
    CC: 61,
    CD: 243,
    KY: 1345,
    CF: 236,
    TD: 235,
    KM: 269,
    HR: 385,
    CG: 242,
    CH: 41,
    CI: 225,
    CK: 682,
    CL: 56,
    CM: 237,
    CN: 86,
    CO: 57,
    CR: 506,
    CU: 53,
    CV: 238,
    CX: 61,
    CY: 357,
    CZ: 420,
    DE: 49,
    DG: 246,
    DJ: 253,
    DK: 45,
    DM: 1767,
    DO: 1,
    DZ: 213,
    EC: 593,
    EE: 372,
    EG: 20,
    SV: 503,
    GQ: 240,
    ER: 291,
    ET: 251,
    FK: 500,
    FO: 298,
    FJ: 679,
    FI: 358,
    FR: 33,
    PF: 689,
    GA: 241,
    GM: 220,
    GE: 995,
    GF: 594,
    GH: 233,
    GI: 350,
    GR: 30,
    GL: 299,
    GP: 590,
    GD: 1473,
    GU: 1671,
    GT: 502,
    GN: 224,
    GW: 245,
    GY: 592,
    HT: 509,
    VA: 39,
    HN: 504,
    HK: 852,
    HU: 36,
    IS: 354,
    IN: 91,
    ID: 62,
    IR: 98,
    IQ: 964,
    IE: 353,
    IM: 44,
    IL: 972,
    IT: 39,
    JM: 1876,
    JP: 81,
    JO: 962,
    KZ: 7,
    KE: 254,
    KI: 686,
    KW: 965,
    KG: 996,
    LA: 856,
    LV: 371,
    LB: 961,
    LS: 266,
    LR: 231,
    LY: 218,
    LI: 423,
    LT: 370,
    LU: 352,
    MO: 853,
    MK: 389,
    MG: 261,
    MH: 692,
    MW: 265,
    MY: 60,
    MV: 960,
    ML: 223,
    MT: 356,
    MR: 222,
    MU: 230,
    YT: 262,
    MX: 52,
    FM: 691,
    MD: 373,
    MC: 377,
    MN: 976,
    ME: 382,
    MS: 1664,
    MA: 212,
    MQ: 596,
    MZ: 258,
    NA: 264,
    NR: 674,
    NP: 977,
    NL: 31,
    AN: 599,
    NC: 687,
    NZ: 64,
    NI: 505,
    NE: 227,
    NG: 234,
    NU: 683,
    KP: 850,
    MP: 1670,
    NO: 47,
    OM: 968,
    PK: 92,
    PW: 680,
    PA: 507,
    PG: 675,
    PY: 595,
    PE: 51,
    PH: 63,
    PN: 870,
    PL: 48,
    PT: 351,
    PR: 1787,
    PS: 970,
    QA: 974,
    RO: 40,
    RU: 7,
    RW: 250,
    SH: 290,
    KN: 1869,
    LC: 1758,
    MF: 599,
    PM: 508,
    VC: 1784,
    WS: 685,
    SM: 378,
    ST: 239,
    SA: 966,
    SN: 221,
    RS: 381,
    SC: 248,
    SL: 232,
    SG: 65,
    SK: 421,
    SI: 386,
    SB: 677,
    SO: 252,
    ZA: 27,
    KR: 82,
    ES: 34,
    LK: 94,
    SD: 249,
    SS: 211,
    SR: 597,
    SZ: 268,
    SE: 46,
    SY: 963,
    TW: 886,
    TJ: 992,
    TZ: 255,
    TH: 66,
    TL: 670,
    TG: 228,
    TK: 690,
    TO: 676,
    TT: 1868,
    TN: 216,
    TR: 90,
    TM: 993,
    TC: 1649,
    TV: 688,
    UG: 256,
    UA: 380,
    AE: 971,
    GB: 44,
    US: 1,
    UY: 598,
    VI: 1340,
    UZ: 998,
    VU: 678,
    VE: 58,
    VN: 84,
    WF: 681,
    YE: 967,
    ZM: 260,
    ZW: 263,
  },
  country_data: {
    AF: 'Afghanistan',
    AL: 'Albania',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AG: 'Antigua and Barbuda',
    AQ: 'Antarctica',
    AR: 'Argentina',
    AS: 'American Samoa',
    AM: 'Armenia',
    AT: 'Austria',
    AU: 'Australia',
    AW: 'Aruba',
    AZ: 'Azerbaijan',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgium',
    BZ: 'Belize',
    BJ: 'Benin',
    BL: 'Saint Barthelemy',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia',
    BA: 'Bosnia and Herzegovina',
    BW: 'Botswana',
    BR: 'Brazil',
    VG: 'British Virgin Islands',
    BN: 'Brunei',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    MM: 'Myanmar',
    BI: 'Burundi',
    KH: 'Cambodia',
    CA: 'Canada',
    CC: 'Cocos (Keeling) Islands',
    CD: 'Democratic Republic of the Congo',
    KY: 'Cayman Islands',
    CF: 'Central African Republic',
    TD: 'Chad',
    KM: 'Comoros',
    HR: 'Croatia',
    CG: 'Congo (Brazzaville)',
    CH: 'Switzerland',
    CI: 'Ivory Coast',
    CK: 'Cook Islands',
    CL: 'Chile',
    CM: 'Cameroon',
    CN: 'China',
    CO: 'Colombia',
    CR: 'Costa Rica',
    CU: 'Cuba',
    CV: 'Cape Verde Island',
    CX: 'The Territory of Christmas Island',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DE: 'Germany',
    DG: 'Diego Garcia',
    DJ: 'Djibouti',
    DK: 'Denmark',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    DZ: 'Algeria',
    EC: 'Ecuador',
    EE: 'Estonia',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    ET: 'Ethiopia',
    FK: 'Falkland Islands',
    FO: 'Faroe Islands',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'France',
    PF: 'French Polynesia',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgia',
    GF: 'French Guiana',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Greece',
    GL: 'Greenland',
    GP: 'Guadeloupe',
    GD: 'Grenada',
    GU: 'Guam',
    GT: 'Guatemala',
    GN: 'Guinea',
    GW: 'Guinea - Bissau',
    GY: 'Guyana',
    HT: 'Haiti',
    VA: 'Vatican City State',
    HN: 'Honduras',
    HK: 'Hongkong',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Iran',
    IQ: 'Iraq',
    IE: 'Ireland',
    IM: 'Isle of Man',
    IL: 'Israel',
    IT: 'Italy',
    JM: 'Jamaica',
    JP: 'Japan',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: 'Laos',
    LV: 'Latvia',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MO: 'Macau',
    MK: 'Macedonia',
    MG: 'Madagascar',
    MH: 'Marshall Islands',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MR: 'Mauritania',
    MU: 'Mauritius',
    YT: 'Reunion Island',
    MX: 'Mexico',
    FM: 'Micronesia',
    MD: 'Moldova',
    MC: 'Monaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Morocco',
    MQ: 'Martinique',
    MZ: 'Mozambique',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands',
    AN: 'Netherlands Antilles',
    NC: 'New Caledonia',
    NZ: 'New Zealand',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue Island',
    KP: 'North Korea',
    MP: 'Northern Mariana Islands',
    NO: 'Norway',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Philippines',
    PN: 'Pitcairn Islands',
    PL: 'Poland',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    PS: 'Palestine',
    QA: 'Qatar',
    RO: 'Romania',
    RU: 'Russia',
    RW: 'Rwanda',
    SH: 'St. Helena',
    KN: 'Saint Kitts and Nevis',
    LC: 'Saint Lucia',
    MF: 'Saint Martin',
    PM: 'Saint Pierre and Miquelon Island',
    VC: 'Saint Vincent and The Grenadines',
    WS: 'Western Samoa',
    SM: 'San Marino',
    ST: 'Sao Tome and Principe',
    SA: 'Saudi Arabia',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SB: 'Solomon Islands',
    SO: 'Somalia',
    ZA: 'South Africa',
    KR: 'South Korea',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SS: 'South Sudan',
    SR: 'Suriname',
    SZ: 'Swaziland',
    SE: 'Sweden',
    SY: 'Syria',
    TW: 'Taiwan',
    TJ: 'Tajikistan',
    TZ: 'Tanzania',
    TH: 'Thailand',
    TL: 'Timor-Leste (East Timor)',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga Islands',
    TT: 'Trinidad and Tobago',
    TN: 'Tunisia',
    TR: 'Turkey',
    TM: 'Turkmenistan',
    TC: 'Turks and Caicos Islands',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'United Arab Emirates',
    GB: 'United Kingdom',
    US: 'United States',
    UY: 'Uruguay',
    VI: 'United States Virgin Islands',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VN: 'Vietnam',
    WF: 'Wallis and Futuna Islands',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
  },
};
